import { clientService } from '../../helpers/services/client.service'
import i18n from '@/i18n'
import { sharedHelper, filtersHelper } from '@/utils'

export const state = {
  list: { data: [], pagination: { pageNumber: 0, pageSize: 0, lastPage: 0, tableRowsCount: 0 } },
  details: {},
  status: { list: true, detail: true, save: true },
}

export const CLIENT_MODULE = 'client'

export const GET_ALL_CLIENTS = 'getAllClients'
export const GET_CLIENT = 'getClient'
export const CREATE_CLIENT = 'createClient'
export const UPDATE_CLIENT = 'updateClient'

const REQUESTING = 'requesting'
const SUCCESS = 'commonSuccess'
const FAILURE = 'commonFailure'
const LIST_SUCCESS = 'listSuccess'
const DETAIL_SUCCESS = 'detailSuccess'

function mapRow(item) {
  return {
    accountNo: item.account_no,
    companyName: item.company_name,
    debtorName: item.debtor_name,
    debtorEmail: item.debtor_email,
    phone1: item.phone1,
    address: item.address,
    currencyCode: item.currency_code,
    agent: item.agent,
    salesAgent: item.sales_agent,
    areaCode: item.area_code,
    creditLimit: item.credit_limit,
    creditTerm: item.credit_term,
    discountPercent: item.discount_percent,
    isActive: item.is_active,
    note: item.note,
    clientGroupId: item.client_group_id,
    clientGroupName: item.client_group_name,
    clientGroupColor: item.client_group_color,
    lastVisitAt: item.last_visit_at || null,
    createdAt: filtersHelper.getDateFormat(item.created_at),
    updatedAt: filtersHelper.getDateFormat(item.updated_at),
  }
}

export const actions = {
  [GET_ALL_CLIENTS]({ commit }, { filter }) {
    commit(REQUESTING, 'list')
    clientService.getAllClients(filter).then((r) => {
      commit(LIST_SUCCESS, r); commit(SUCCESS)
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE)
    })
  },
  [GET_CLIENT]({ commit }, { accountNo }) {
    commit(REQUESTING, 'detail')
    return clientService.getClient(accountNo).then((r) => {
      commit(DETAIL_SUCCESS, r); commit(SUCCESS); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE)
    })
  },
  [CREATE_CLIENT]({ commit }, { data }) {
    commit(REQUESTING, 'save')
    return clientService.createClient(data).then((r) => {
      sharedHelper.alertSuccessMessage(i18n.t('label.createX', [i18n.t('module.client')]))
      commit(SUCCESS)
      // The response carries the generated account_no, which the caller needs
      // to show. Still truthy, so `if (await createClient(...))` keeps working.
      return r || true
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE); return false
    })
  },
  [UPDATE_CLIENT]({ commit }, { accountNo, data }) {
    commit(REQUESTING, 'save')
    return clientService.updateClient(accountNo, data).then(() => {
      sharedHelper.alertSuccessMessage(i18n.t('label.updateX', [i18n.t('module.client')]))
      commit(SUCCESS); return true
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE); return false
    })
  },
}

export const mutations = {
  [LIST_SUCCESS](state, data) {
    const items = data.data || []
    state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)
    state.list.data = data.success ? items.map(mapRow) : items
  },
  [DETAIL_SUCCESS](state, data) {
    state.details = data.data ? mapRow(data.data) : {}
  },
  [FAILURE](state) { state.status = { list: true, detail: true, save: true } },
  [REQUESTING](state, type) { state.status[type] = false },
  [SUCCESS](state) { state.status = { list: true, detail: true, save: true } },
}
